import React, { useState } from "react";

// const DemoToggle = ({ label }) => {
//   const [state, setState] = useState("center");

//   const getClass = () => {
//     if (state === "left") return "custom-toggle left";
//     if (state === "right") return "custom-toggle right";
//     return "custom-toggle";
//   };

//   const getStatusText = () => {
//     if (state === "left") return "Status: Issue (Red)";
//     if (state === "right") return "Status: Working (Green)";
//     return "Status: Inactive";
//   };

//   const handleSideClick = (side) => {
//     if (state !== side) {
//       setState(side);
//     }
//   };

//   return (
//     <div className="toggle-container">
//       <div className="toggle-label">{label}</div>
//       <div className={getClass()}>
//         <div
//           className="click-zone left-zone"
//           onClick={() => handleSideClick("left")}
//         />
//         <div
//           className="click-zone center-zone"
//           onClick={() => handleSideClick("center")}
//         />
//         <div
//           className="click-zone right-zone"
//           onClick={() => handleSideClick("right")}
//         />
//         <div className="knob"></div>
//       </div>
//       <div className="status">{getStatusText()}</div>
//     </div>
//   );
// };

// export default DemoToggle;

const DemoToggle = ({ value, onChange }) => {
  const getClass = () => {
    if (value === "left") return "custom-toggle left";
    if (value === "right") return "custom-toggle right";
    return "custom-toggle";
  };

  const handleClick = (side) => {
    if (value !== side) {
      onChange(side);
    }
  };

  return (
    <div className={getClass()}>
      <div
        className="click-zone left-zone"
        onClick={() => handleClick("left")}
      />
      <div
        className="click-zone center-zone"
        onClick={() => handleClick("center")}
      />
      <div
        className="click-zone right-zone"
        onClick={() => handleClick("right")}
      />
      <div className="knob"></div>
    </div>
  );
};

export default DemoToggle;